module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"af_header_1":"言語を選択","af_header_2":"問い合わせる"},"en":{"af_header_1":"Select Language","af_header_2":"Inquire"},"ko":{"af_header_1":"언어 선택","af_header_2":"우리에게 문의"},"zh-cn":{"af_header_1":"用AI提升动画画质。","af_header_2":"咨询我们"},"zh-tw":{"af_header_1":"用AI提升動畫畫質。","af_header_2":"諮詢我們"}}')
  delete Component.options._Ctor
}
